import { BirdviewCard } from '../BirdviewCard'
import { BirdviewDocumentRow } from '../BirdviewDocumentRow'
import { BIRDVIEW_SECTION_TARGET } from '../DashboardBirdview.constants.targets'
import { useBirdviewListTarget } from '../DashboardBirdview.hooks'

// A file has no profile page of its own, so a row opens the documents section
// the same way the card's "show all" does.
function BirdviewDocumentsWidget({
  dragHandleProps,
  section,
  title,
  onNavigate,
}) {
  const { getListTarget } = useBirdviewListTarget()

  function handleOpenDocuments() {
    onNavigate(getListTarget(BIRDVIEW_SECTION_TARGET.dwellerDocuments))
  }

  return (
    <BirdviewCard
      count={section.total}
      dragHandleProps={dragHandleProps}
      hasMore={section.hasMore}
      state={section.state}
      title={title}
      onRetry={section.reload}
      onShowAll={handleOpenDocuments}
    >
      {section.items.map(item => (
        <BirdviewDocumentRow
          item={item}
          key={item.id}
          onOpen={handleOpenDocuments}
        />
      ))}
    </BirdviewCard>
  )
}

export default BirdviewDocumentsWidget
